// @flow

// Vendors
import React, { type Element } from 'react';
import { Transition } from 'react-transition-group';
import classnames from 'classnames';

// Helpers
import { triggerBrowserReflow } from '../../../../lib/helpers/';

// Styles
import './collapse-transition.scss';

// Types
type Props = {
  className?: string,
  children: Element<any>,
};

const CollapseTransition = ({ className, children, ...props }: Props) => {
  function handleExit(elem) {
    elem.style.height = `${elem.offsetHeight}px`;
    triggerBrowserReflow(elem);
  }

  function handleExiting(elem) {
    elem.style.height = '0';
  }

  return (
    <Transition
      {...props}
      timeout={200}
      onExit={handleExit}
      onExiting={handleExiting}
      unmountOnExit
    >
      {(status, innerProps) =>
        React.cloneElement(children, {
          ...innerProps,
          className: classnames(
            className,
            children.props.className,
            `collapse-transition collapse-transition-${status}`
          ),
        })
      }
    </Transition>
  );
};

export default CollapseTransition;
